














































import { Vue, Component, Prop } from 'vue-property-decorator';
import Assessment from '@/domain/assessment/entity/assessment';

@Component
class AssessmentHeaderCard extends Vue {
  @Prop({ type: Object, required: true }) assessment!: Assessment;

  @Prop({ type: Boolean, required: true }) showEditButton!: boolean;

  @Prop({ type: Boolean, required: true }) showSaveButton!: boolean;

  @Prop({ type: Boolean, required: true }) isEditMode!: boolean;

  @Prop({ type: Boolean, required: true }) loadingSave!: boolean;
}

export default AssessmentHeaderCard;
